import { render } from "./oficialiaVBCCP.vue?vue&type=template&id=c90dd162&scoped=true"
import script from "./oficialiaVBCCP.vue?vue&type=script&lang=js"
export * from "./oficialiaVBCCP.vue?vue&type=script&lang=js"

import "./oficialiaVBCCP.vue?vue&type=style&index=0&id=c90dd162&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90dd162"]])

export default __exports__